import React, {useEffect, useRef, useState} from 'react';
import {Button, Card, Checkbox, Col, Divider, Flex, Form, Input, Row} from "antd";
import {StyledPopUp} from "../../../../shared";
import {ConditionsPopupProps} from "../../models";
import {useForm} from "antd/es/form/Form";
import {StyledCard, StyledFormItemCard} from "./ConditionsPopup.styled";
import {useLocation} from "react-router-dom";
import {connect} from "react-redux";
import {getProductConditions} from "../../actions/AdInsert.action";
import {withRouter} from "../../../../utils/services/with-router";

const {TextArea} = Input;

const ConditionsPopup = ({open, onCansel, getProductConditions, onConfirm}: ConditionsPopupProps) => {
    const textAreaRefs = useRef({}); // Keyed by field key/index

    const handleClick = (key: any, value: any) => {
        // @ts-ignore
        const textarea = textAreaRefs.current[key];
        if (!textarea) return;

        textarea.focus();

        setTimeout(() => {
            const cursorPos = textarea.selectionStart;
            const regex = /{{[^}]+}}/g;
            let match;
            while ((match = regex.exec(value)) !== null) {
                const start = match.index;
                const end = start + match[0].length;
                if (cursorPos >= start && cursorPos <= end) {
                    textarea.setSelectionRange(start, end);
                    break;
                }
            }
        }, 100);
    };
    const [form] = useForm();
    const [propertiesData, setPropertiesData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const location = useLocation();

    const getList = () => {
        setLoading(true);
        getProductConditions(location.state.stepOneForm.subCategoryId)
            .then((data: any) => {
                if (data.payload) {
                    const conditionsData = data.payload.data.map((item: any, index: number) => ({
                        name: item.name,
                        conditions: item.productConditionTemplates.map((condition: any) => ({
                            ...condition,
                            description: location.state?.stepTwoForm?.productConditions?.find((i: any) => i.productConditionTemplateId === condition.id)?.description || condition.description,
                            isChecked:location.state?.stepTwoForm ?  location.state?.stepTwoForm?.productConditions?.find((i: any) => i.productConditionTemplateId === condition.id) : true,
                            productConditionTemplateId: condition.id,
                        })),
                    }));
                    console.log(conditionsData);
                    form.setFieldsValue({templates: conditionsData});
                    setPropertiesData(conditionsData);
                }
                setLoading(false);
            })
            .catch(() => setLoading(false));
    };

    useEffect(() => {
        getList();
    }, []);
    useEffect(() => {
        console.log(form.getFieldsValue());
    }, [form]);

    const onFinish = (values: any) => {
        const selectedConditions = values.templates.flatMap((template: any) =>
            template.conditions.filter((condition: any) =>
                condition.isChecked)
        );
        onConfirm(selectedConditions);
        onCansel();
        console.log(selectedConditions);
    };
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);
    useEffect(() => {
        const handleResize = () => {
            setScreenHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);

        // Cleanup event listener on component unmount
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return (
        <StyledPopUp open={open} onCancel={onCansel} width={"100%"} footer={null} transitionName=""

                     title={
                         <div style={{display: "flex", flexDirection: "column"}}>
                             <span style={{fontSize: "18px", fontWeight: 600}}>تعیین شرایط نگهداری و تحویل</span>
                             <span style={{fontSize: "12px", color: "#818181ff", marginTop: "4px"}}>
🧾 تعیین شرایط نگهداری و تحویل

در این بخش مفاد قرارداد اجاره میان شما و آگهی‌دهنده به زبان ساده آورده شده است.
<br/>
هر بند را می‌توانید بررسی، و در صورت تمایل ویرایش کنید یا با برداشتن تیک کنار آن، از مفاد قرارداد حذف نمایید.
<br/>
عباراتی که درون <span style={{color: "#000"}}>&#123;&#123;</span> ... <span style={{color: "#000"}}>&#125;&#125;</span> قرار دارند، متغیرهایی قابل ویرایش هستند تا بتوانید شرایط دقیق‌تری را مطابق توافق خود وارد کنید.</span>
                         </div>
                     }
        >
            <Flex vertical gap={"small"} >
                <Form layout={"vertical"} form={form} onFinish={onFinish}
                      onFieldsChange={() => console.log(form.getFieldsValue())}>
                    <Flex vertical gap={"small"} style={{maxHeight: `${screenHeight-250}px`, overflowY: "auto"}}>
                        <Form.List name="templates">
                            {(fields) => (
                                <>
                                    {fields.map(({key, name, ...restField}) => (

                                        <Flex vertical key={key} gap={"large"}>
                                            <StyledCard title={propertiesData[name]?.name}>

                                                <Form.List name={[name, "conditions"]}>
                                                    {(conditionFields) => (
                                                        <>
                                                            {conditionFields.map(({
                                                                                      key: conditionKey,
                                                                                      name: conditionName,
                                                                                      ...conditionRestField
                                                                                  }) => (
                                                                <StyledFormItemCard>
                                                                    <Flex vertical style={{marginBottom: "15px"}}>
                                                                        <Form.Item  {...restField}
                                                                                    name={[conditionName, 'isChecked']}
                                                                                    valuePropName={"checked"}
                                                                                    label={null}>
                                                                            <Checkbox onChange={(e) => {
                                                                                // Update the corresponding form value dynamically
                                                                                const updatedData = [...propertiesData];
                                                                                updatedData[key].conditions[conditionName].isChecked = e.target.checked;
                                                                                setPropertiesData(updatedData);
                                                                                form.setFieldsValue({templates: updatedData});
                                                                            }}>{propertiesData[name]?.conditions[conditionName]?.name}</Checkbox>
                                                                        </Form.Item>
                                                                        {propertiesData[name]?.conditions[conditionName]?.isChecked &&
                                                                            <Form.Item {...conditionRestField}
                                                                                       name={[conditionName, "description"]}>
                                                                                <TextArea
                                                                                    autoSize
                                                                                    placeholder={'توضیحات'}
                                                                                    ref={(el) => {
                                                                                        // @ts-ignore
                                                                                        textAreaRefs.current[`${name}-${conditionName}`] = el?.resizableTextArea?.textArea;
                                                                                    }}
                                                                                    onClick={() => {
                                                                                        const value = form.getFieldValue(['templates', name, 'conditions', conditionName, 'description']);
                                                                                        if (value) handleClick(`${name}-${conditionName}`, value);
                                                                                    }}
                                                                                    onTouchStart={() => {
                                                                                        const value = form.getFieldValue(['templates', name, 'conditions', conditionName, 'description']);
                                                                                        if (value) handleClick(`${name}-${conditionName}`, value);
                                                                                    }}
                                                                                    rows={4}
                                                                                />
                                                                            </Form.Item>}

                                                                    </Flex>
                                                                </StyledFormItemCard>

                                                            ))}
                                                        </>
                                                    )}
                                                </Form.List>
                                            </StyledCard>

                                        </Flex>
                                    ))}
                                </>
                            )}
                        </Form.List>
                    </Flex>
                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                        <Row justify={"center"}>
                            <Button size={"large"} type="primary" block htmlType={"submit"}>انتخاب کنید</Button>
                        </Row>
                    </Col>
                </Form>
            </Flex>
        </StyledPopUp>
    );
};
export default connect(null, {getProductConditions})(withRouter(ConditionsPopup));
